// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"UserAvatar_userAvatar__dQbCU","avatar":"UserAvatar_avatar__oo_sT","avatarPlaceholder":"UserAvatar_avatarPlaceholder__5fKjk"};